import { render, staticRenderFns } from "./WhyBlock.vue?vue&type=template&id=d49aa164&scoped=true&"
import script from "./WhyBlock.vue?vue&type=script&lang=js&"
export * from "./WhyBlock.vue?vue&type=script&lang=js&"
import style0 from "./WhyBlock.vue?vue&type=style&index=0&id=d49aa164&lang=scss&scoped=true&"
import style1 from "./WhyBlock.vue?vue&type=style&index=1&id=d49aa164&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49aa164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d49aa164')) {
      api.createRecord('d49aa164', component.options)
    } else {
      api.reload('d49aa164', component.options)
    }
    module.hot.accept("./WhyBlock.vue?vue&type=template&id=d49aa164&scoped=true&", function () {
      api.rerender('d49aa164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/WhyBlock.vue"
export default component.exports